/* eslint-disable n/handle-callback-err */
import { useContext, createContext } from "react"
import axios from "axios"

import { LogsInitContext } from "../LogsInitComponentesContext/LogsInitComponentesContext"
import { showNotify } from "../../Utils/Utils"

export const ConexaoServerContext = createContext()

let conexao = {
    ip: window.location.hostname,
    porta_api: null
}

export const ConexaoServerProvider = ({ children }) => {
    const { LogInit } = useContext(LogsInitContext)
    LogInit('ConexaoServerProvider', 'contexto')

    // useEffect(() => {
    //     setConfigServer()
    // }, [])

    const getConfigServer = async () => {
        if (!conexao.porta_api) {
            await setConfigServer()
        }
        return conexao
    }

    const setConfigServer = async () => {
        let path = `http://${window.location.hostname}/wsOnePortaria/getConfig.php`
        await axios.get(path, { timeout: 2000 })
            .then((resp) => {
                if (resp.status == 200 && resp.data) {
                    conexao.porta_api = resp.data.porta_api
                }
            })
            .catch(async (e) => {
                const msg = `Erro ao buscar informações de conexão com o servidor: ${path}`
                console.log(msg, e)
                showNotify('error', msg, 7000)
            })
    }

    let value = { getConfigServer }

    return (
        <ConexaoServerContext.Provider value={value}>
            <div>
                {children}
            </div>
        </ConexaoServerContext.Provider>
    )
}
